import React, { useEffect, useRef, useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDeletePics } from '../hooks/useDeletePics';
import axios from 'axios';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { define, maxNameLength } from '../data/globals'
import { useNotify } from '../hooks/useNotify';

const MultiUpload = () => {
    // Redux
    const dispath = useDispatch()
    const picsInDBStore = useSelector(state => state.picsInDB)
    const newPicsStore = useSelector(state => state.newPics)
    
    const { deleteNewPics } = useDeletePics()
    const refFiles = useRef()
    const [files, setFiles] = useState([])
    const [isInProgress, setIsInProgress] = useState(false)
    const [uploadPercentage, setUploadPercentage] = useState(0)
    const [uplBtnBlock, setUplBtnBlock] = useState(true)
    const [uplTitle, setUplTitle] = useState(false)
    const { pushNotify } = useNotify()

    // Отслеживаем изменение массива newPics (в сторе)
    useEffect(() => {
        if(newPicsStore.length === 0) {
            hideBarAndClean()
            setUplTitle(false)
        } else {
            setUplTitle(true)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newPicsStore])
    
    // Закрыто или открыто окно выбора файлов
    const handleFilesUpload = () => {
        setFiles(refFiles.current.files)
        setIsInProgress(true)
        // Если выбраны файлы, то кнопку "загрузить" можно разблокировать
        if(refFiles.current.files.length > 0) setUplBtnBlock(false)
        else setUplBtnBlock(true)
    }
    // Загрузка файлов
    async function submitFiles(e){
        e.preventDefault() // специально для Firefox

        setUploadPercentage(0)
        setUplBtnBlock(true)

        let file
        let formData = new FormData();
        
        for( let i = 0; i < files.length; i++){
            file = files[i];
            formData.append('files[' + i + ']', file);
        }// for

        try {
            const response = await axios({
                method: 'post',
                url: define.pathToAPI + '/multiupload/multiupload.php',
                data: formData,
                // ########################################################
                // userToken: localStorage.getItem('AuthToken'),
                // ########################################################
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function(progressEvent) {
                    setUploadPercentage(Math.round( (progressEvent.loaded * 100) / progressEvent.total ))
                }
                // .bind(this)
            })
            // console.log('response: ', response);
            
            if(!response.data.uplFiles) {
                console.log('! Не получен response.data.uplFiles');
                // alert('Ошибка на сервере при сохранении файлов (см. консоль)')
                pushNotify( 'Ошибка на сервере при сохранении файлов (см. консоль)', 'notifyOrange')
                return
            }

            // проверка ответа от php файла
            if(response.data) {
                // Включение заморозки действий
                dispath({ type: 'SetFreeze', value: true})

                // Если в newPics еще нет такого элемента, тогда добавляем
                for( let j = 0; j < response.data.uplFiles.length; j++) {
                    if (!newPicsStore.includes(response.data.uplFiles[j])) {
                        // Отправляем список новых файлов в стор
                        dispath({ type: 'AddNewPics', newPics: response.data.uplFiles[j] })
                        // Здесь, возможно лучше сделать через tempArr. А после цикла уже отправлять в стор готовый массив
                    }
                }// for

            } else {
                console.log('Ошибка при передаче или сохранении файлов.\nСервер отвечает (код 200). Но нет подтверждения от multiupload.php, что файлы сохранены')
                alert('Ошибка (см. консоль)')
            }
        } catch (e) {

            if(e.code === 'ERR_NETWORK') {
                // Нет подключения к серверу
                pushNotify( 'Нет подключения к серверу', 'notifyOrange')
                // console.log('Нет подключения к серверу')
                return
            }

            // Обработка ошибок
            switch(e.response.data.status) {
                default:
                    // this.pushNotify( notifys[this.lang].defaultError, 'notifyOrange')
                    console.log('Error: ' + e)
                    break
            } // switch
        }// try
        
    }// submitFiles

    // Подготовка к удалению картинки. Удаляю из стора и добавляю в массив picsToDelete - файлы, которые будут удалены (с сервера и базы, при сохранении ProdFormUpdate)
    function preparePicToDelete( e, filename ) {
        e.preventDefault()

        if( !filename && typeof filename !== 'string' ) {
            console.log('Ошибка: filename не передан или не string [см. preparePicToDelete()]');
            return }
        // Включение заморозки действий
        dispath({ type: 'SetFreeze', value: true})
        // Формируем массив без элемента filename
        const filteredArr = picsInDBStore.filter(item => item !== filename)
        // "Запоминаем" файл (в массиве), чтобы удалить позже при сохранении ProdFormUpdate
        dispath({ type: 'AddPicsToDelete', picsToDelete: filename })
        // Сохраняем обновленный массив в сторе
        dispath({ type: 'UpdatePicsInDB', picsInDB: filteredArr })
    }// preparePicToDelete
    
// // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//     // Удаление файлов массива picsToDelete
//     function delPicsToDelete() {
//         if(picsToDeleteStore.length > 0) deleteFiles( picsToDeleteStore )
//         // Очищаем массив
//         dispath({ type: 'ClearPicsToDelete' })// this.picsToDelete = []
//     }
// // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

// // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
//     // Возврат элементов из picsToDelete в стор picsInDB
//     function getBackFiles() {
//         if(picsToDeleteStore.length > 0) 
//         dispath({ type: 'AddToPicsInDB', picsInDB: picsToDeleteStore })// this.$store.commit('addToPicsArr', this.picsToDelete)
//         // Очищаем массив
//         dispath({ type: 'ClearPicsToDelete'})// this.picsToDelete = []
//     }// getBackFiles
// // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    // Очистка массива файлов, скрытие прогресс-бара и очистка поля input
    function hideBarAndClean() {
        const delay = 350 // ждем пока отработают transition у .fade  и .list (при transition .7s красиво с delay = 300 (350). То есть ~ половина transition)
        const afterSmooth = 600 // Если у .smooth transition: .5s (500 мсек), то afterSmooth ставим немного больше. Например, 600 (мсек)
        // Совет: для стилей .fade  и .list, нужно ставить одинаковую длительность transition. Чтобы переходы у списка и текста "Загружены файлы" отрабатывали синхронно.

        setTimeout(() => { setIsInProgress(false) }, delay);
        refFiles.current.value = null // Очистка поля input (multiple)
        setTimeout(() => { setUploadPercentage(0) }, delay + afterSmooth);
    }

    return (
        <div className="graybg">
            <div className={(picsInDBStore.length > 0) ? 'picsArrBg pl-15 pt-15 pb-6 smooth smooth-show' : 'pl-15 smooth'}>
                <ul className="">
                    {picsInDBStore.map((item) => 
                        <li key={item}
                            className={item.includes('_COPY') ? 'flex-list orange' : 'flex-list'}>
                            <a href={define.uploadsFolder + item} className='' target='_blank' rel='noreferrer noopener' title=''
                            ><img src={define.prevFolder + item} className="prev" alt="" /></a>
                            <div className='picName'>
                                <a href={define.uploadsFolder + item} target='_blank' rel='noreferrer noopener' title='Открыть в новой вкладке'>{ item.length > maxNameLength ? item.substr(0, maxNameLength - 13) + ' ... ' + item.substr(-8, 8) : item }</a>
                            </div>
                            <div className='delPic'
                                onClick={(e)=>preparePicToDelete(e, item)}><img src={ define.pathToGraphics + '/delete2_20px.png' } alt=''/></div>
                        </li>
                    )}
                </ul>
            </div>

            <div className="multiSelect mb-15">
                <div className="flex mr-15">
                    <input type="file" id="files" ref={refFiles} accept=".png, .jpg, .jpeg, .gif" className="" multiple onChange={handleFilesUpload}/><br/>
                    <button
                        disabled={uplBtnBlock}
                        onClick={submitFiles}
                        >Загрузить</button>
                </div>
                
                <div className={isInProgress ? 'smooth smooth-show' : 'smooth'}>
                    <div className="mt-20 mb-10">
                        { uploadPercentage } % <br/>
                        <div className="progress">
                        <div className="progress-bar" style={{ width: + uploadPercentage + '%' }}></div>
                        </div>
                    </div>
                </div>

                <span>
                    <CSSTransition
                        in={uplTitle}
                        timeout={500}
                        classNames="uplTitle"
                        mountOnEnter
                        unmountOnExit
                    >
                        <div className="mt-10 mb-10">Загружены файлы ({newPicsStore.length}):</div>
                    </CSSTransition>
                    <ul className="ml-15">
                    <TransitionGroup className="">
                        {newPicsStore.map(item =>
                        <CSSTransition
                            key={item}
                            timeout={500}
                            classNames="uplPics"
                            mountOnEnter
                            unmountOnExit
                        >
                            <li
                                className={item.includes('_COPY') ? 'flex-list orange' : 'flex-list'}
                                key={item}>                                
                                <img src={define.prevFolder + item} className="prev" alt="" />
                                <div className='picName'>
                                    { item.length > maxNameLength ? item.substr(0, maxNameLength - 13) + ' ... ' + item.substr(-8, 8) : item }
                                </div>
                                <div className='delPic'
                                    onClick={(e) => {
                                        e.preventDefault();
                                        deleteNewPics(item)} }
                                    ><img src={ define.pathToGraphics + '/delete2_20px.png' } alt=''/></div> 
                            </li>
                        </CSSTransition>
                        )}
                    </TransitionGroup>
                    </ul>
                </span>
            </div>
        </div>

    )
}

const memoMultiUpload = memo(MultiUpload, (prevProp, nextProp)=>{
    if(prevProp.newPicsStore === nextProp.newPicsStore) return true
    return false
})

export default memoMultiUpload